type SentryReactModule = {
  init: (options: Record<string, unknown>) => void;
  browserTracingIntegration?: () => unknown;
  replayIntegration?: (options?: Record<string, unknown>) => unknown;
};

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}

function parseSampleRate(value: string | undefined, fallback: number): number {
  const parsed = Number(value);
  if (Number.isNaN(parsed) || parsed < 0 || parsed > 1) return fallback;
  return parsed;
}

export async function initFrontendSentry(): Promise<void> {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) {
    return;
  }
  const release = (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) || __SENTRY_RELEASE__;
  const environment =
    (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ||
    __SENTRY_ENVIRONMENT__ ||
    import.meta.env.MODE;

  try {
    const mod = (await import('@sentry/react')) as SentryReactModule;
    const integrations: unknown[] = [];

    if (typeof mod.browserTracingIntegration === 'function') {
      integrations.push(mod.browserTracingIntegration());
    }

    if (typeof mod.replayIntegration === 'function') {
      integrations.push(
        mod.replayIntegration({
          maskAllText: false,
          blockAllMedia: true,
        })
      );
    }

    mod.init({
      dsn,
      environment,
      release,
      autoSessionTracking: true,
      integrations,
      tracesSampleRate: parseSampleRate(
        import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string | undefined,
        0.1
      ),
      replaysSessionSampleRate: parseSampleRate(
        import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE as string | undefined,
        0
      ),
      replaysOnErrorSampleRate: parseSampleRate(
        import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE as string | undefined,
        1
      ),
    });

    console.log('[Sentry] Frontend initialized');
  } catch (error: unknown) {
    console.warn('[Sentry] Frontend init failed:', getErrorMessage(error));
  }
}
